"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TSGameSnakeLong = exports.TSGameSnakeBasic = void 0;
const TSBlock_1 = require("./TSBlock");
const TSColors_1 = require("./TSColors");
class TSGameSnake {
    constructor() {
        this.path = [];
    }
    onStart(scene) {
        this._scene = scene;
        this._applesCollected = 0;
        this._totalApples = 0;
    }
    addSnake(startLen, x, y) {
        this._startLen = startLen;
        const block = new TSBlock_1.TSBlock(this._scene, TSColors_1.TSBlockType.Green, TSBlock_1.TSBlockAttribute.LoseOnTouch);
        this.gameInterface.addBlock(block, x, y, true);
        this.path.push(block);
    }
    addApple(x, y) {
        this._totalApples++;
        const block = new TSBlock_1.TSBlock(this._scene, TSColors_1.TSBlockType.Red, TSBlock_1.TSBlockAttribute.None);
        this.gameInterface.addBlock(block, x, y, false);
    }
    addObstacle(x, y) {
        const block = new TSBlock_1.TSBlock(this._scene, TSColors_1.TSBlockType.Gray, TSBlock_1.TSBlockAttribute.LoseOnTouch);
        this.gameInterface.addBlock(block, x, y, false);
    }
    onWillMove(block) {
    }
    updatePlayerPath(oldFront, path) {
        for (let i = 1; i < path.length; i++) {
            const pos = path[i].pos;
            this.gameInterface.grid.forceMoveTo(path[i], ...oldFront);
            oldFront = [pos.x, pos.y];
        }
        if (path.length < this._startLen + this._applesCollected && path.length > 0) {
            const block = new TSBlock_1.TSBlock(this._scene, path[0].getType(), path[0].attr);
            this.gameInterface.addBlockNoAnim(block, oldFront[0], oldFront[1]);
            path.push(block);
        }
    }
    killPath(path) {
        for (let block of path) {
            block.kill();
        }
    }
    onDidMove(block, previousPos, desiredPos, successfullyMoved) {
        // Have to check for apples before updating player path, as it can 
        // influence how long the snake should be.
        let others = this.gameInterface.blocksAt(block.pos.x, block.pos.y);
        for (let i = 0; i < others.length; i++) {
            if (others[i] == block)
                continue;
            if (others[i].attr == TSBlock_1.TSBlockAttribute.None) {
                this._applesCollected++;
                others[i].kill();
            }
        }
        this.updatePlayerPath(previousPos, this.path);
        // Have to check lost after updating path, as otherwise they could hit
        // their tail even though it should've moved.
        let lost = false;
        others = this.gameInterface.blocksAt(block.pos.x, block.pos.y);
        for (let i = 0; i < others.length; i++) {
            if (others[i] == block)
                continue;
            if (others[i].attr == TSBlock_1.TSBlockAttribute.LoseOnTouch) {
                lost = true;
                break;
            }
        }
        // Check player lose
        if (!successfullyMoved || lost) {
            this.killPath(this.path);
            this.gameInterface.lose();
            return;
        }
        if (this._applesCollected == this._totalApples) {
            this.gameInterface.win();
        }
    }
}
class TSGameSnakeBasic extends TSGameSnake {
    onStart(scene) {
        super.onStart(scene);
        this.addSnake(3, 1, 4);
        const apples = [[5, 0], [0, 1], [3, 2], [2, 4], [5, 4]];
        apples.forEach(x => this.addApple(...x));
        const obstacles = [[3, 0], [2, 2], [4, 2], [5, 2], [3, 4], [3, 5]];
        obstacles.forEach(x => this.addObstacle(...x));
    }
}
exports.TSGameSnakeBasic = TSGameSnakeBasic;
class TSGameSnakeLong extends TSGameSnake {
    onStart(scene) {
        super.onStart(scene);
        this.addSnake(3, 1, 1);
        const obstacles = [[2, 2], [2, 3], [3, 2], [3, 3], [0, 2], [3, 1], [3, 4], [4, 2]];
        obstacles.forEach(x => this.addObstacle(...x));
        const apples = [
            [2, 5], [3, 0], [4, 4], [0, 1], [0, 3],
            [1, 5], [5, 5], [0, 5], [4, 1], [0, 0],
            [2, 1], [0, 4], [4, 0], [2, 0], [5, 0],
            [1, 0], [5, 1], [5, 3], [2, 4], [1, 4],
            [3, 5], [5, 4]
        ];
        apples.forEach(x => this.addApple(...x));
    }
}
exports.TSGameSnakeLong = TSGameSnakeLong;
